<app-loading></app-loading>
<app-header *ngIf="router.url !== '/login' && router.url !== '/loading'  && router.url !== '/upgrade' && !app.fullscreen"></app-header>
<div id="div-content">
  <router-outlet></router-outlet>
</div>